import { cloneDeep } from 'lodash';
import { createReducer, on } from '@ngrx/store';

import { Company } from '../../shared/company';
import { PremiitError } from '../../utils/premiit-error';
import { RouteLink } from '../../shared/header/route-link';
import { User } from '../../pages/users/user';
import * as authActions from '../actions';

export interface AuthState {
  company: Company;
  user: User;
  loading: boolean;
  error: PremiitError;
  routes: RouteLink[];
}

export const initialState: AuthState = {
  company: null,
  user: null,
  loading: false,
  error: null,
  routes: []
};

const _authReducer = createReducer(initialState,
  on(authActions.registerCompanyAction, (state, { company }) => ({ ...state, loading: true })),
  on(authActions.registerSuccess, (state, { authData }) => (
    {
      ...state,
      company: { ...authData.company },
      user: { ...authData.user },
      error: null,
      loading: false,
    }
  )),
  on(authActions.registerError, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(authActions.loginAction, (state) => ({ ...state, loading: true })),
  on(authActions.loginSuccess, (state, { response }) => (
    {
      ...state,
      loading: false,
      error: null,
      user: { ...response.user },
      company: { ...response.user.company },
      permissions: [...response.permissions],
      routes: [...response.routes]
    }
  )),
  on(authActions.loginError, (state, { error}) => ({...state, loading: false, error })),
  on(authActions.retrieveSessionAction, (state) => ({ ...state, loading: true })),
  on(authActions.retrieveSessionSuccess, (state, response) => {
    return  (
      {
        ...state,
        loading: false,
        error: null,
        company: { ...response.user.company },
        user: { ...response.user },
        permissions: [...response.permissions],
        routes: [...response.routes]
      }
    );
  }),
  on(authActions.retrieveSessionError, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(authActions.logOutAction, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(authActions.logOutSucessAction, (state) => ({
    ...state,
    loading: false,
    company: null,
    user: null,
    error: null,
  })),
  on(authActions.addNewStore, (state: AuthState, { store }) => {
    const user: User = cloneDeep(state.user);
    user.stores.push(store);
    return { ...state, user };
  }),
  on(authActions.setLoading, (state: AuthState, { loading }) => {
    return { ...state, loading };
  })
);

export function AuthReducer(state, action): any {
  return _authReducer(state, action);
}
